import { useParams } from "react-router";

import theme from "theme";
import { colors } from "theme/palette";

import PageHeader from "components/PageHeader";
import Paper from "components/Paper";
import Stack from "components/Stack";
import Text from "components/Text";

import ESignAssigneeModificationTable from "entities/Memo/components/ESignAssigneeModificationTable";

const ESignSettings = () => {
  const params = useParams<{
    dealId: string;
  }>();
  const dealId = Number(params.dealId);

  return (
    <>
      <Paper
        sx={{
          padding: theme.spacing(0, 4, 1, 4),
          flex: 1,
        }}
      >
        <PageHeader title="E-sign settings" />
        <Stack padding={3} maxWidth="md">
          <Text variant="text1" fontWeight="bold">
            Assigned e-sign roles: deal level
          </Text>
          <Text
            marginTop={0.5}
            marginBottom={3}
            variant="text3"
            color={colors.gray80}
          >
            These are the e-sign roles present in your deal documents. By
            assigning a person to each role here, the contact details will be
            automatically added when you are preparing your documents.
          </Text>

          <ESignAssigneeModificationTable dealId={dealId} />
        </Stack>
      </Paper>
    </>
  );
};

export default ESignSettings;
